export const HttpConstants = {
  CacheIntercept: 'Cache-Intercept'
};
